import { Fragment } from 'react';

// Brand headline renderer: every capital O (and the 0 in "360°") renders in brand red,
// matching the design system. Lets section headlines be CMS-editable plain strings.
export default function RedO({ text }) {
  const parts = String(text).split(/([O0])/g);
  return parts.map((part, i) =>
    part === 'O' || part === '0' ? <span key={i} className="o-red">{part}</span> : <Fragment key={i}>{part}</Fragment>
  );
}
